<style >

  .router-fade-enter-active, .router-fade-leave-active {
    transition: opacity .3s;
  }
  .router-fade-enter, .router-fade-leave-active {
    opacity: 0;
  }
</style>

<template>
	<div v-wechat-title="$route.meta.title">
    <transition name="router-fade" mode="out-in">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
    </transition>

    <transition name="router-fade" mode="out-in">
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</transition>
  </div>


</template>
<script>
  export default {
    created() {

    },
    components: {
    }
  }
</script>






// WEBPACK FOOTER //
// src/App.vue